import React from "react";
import styled from "styled-components";
import { colors } from "../styles/colors";
import { motion } from "framer-motion";

const ContactSection = styled.section`
  padding: 120px 20px;
  text-align: center;
  background-color: ${colors.secondary};
  color: ${colors.textLight};
`;

const Heading = styled.h2`
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  margin-bottom: 15px;
  color: ${colors.primary};
`;

const Subtitle = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 50px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 600px;
  margin: 0 auto;
  gap: 20px;

  input, textarea {
    padding: 16px;
    border: 1px solid rgba(255,255,255,0.15);
    background-color: rgba(255,255,255,0.02);
    color: #fff;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.9rem;
    
    &:focus {
      outline: none;
      border-color: ${colors.primary};
      background-color: rgba(255,255,255,0.05);
    }
  }

  textarea {
    resize: vertical;
  }

  button {
    font-family: 'Montserrat', sans-serif;
    padding: 16px;
    background-color: ${colors.primary};
    color: ${colors.secondary};
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #ffffff;
      color: ${colors.secondary};
    }
  }
`;

export default function Contact() {
  return (
    <ContactSection id="contact">
      <Heading>Book Free Consultation</Heading>
      <Subtitle>Initiate your enterprise structural transformation today.</Subtitle>
      <Form>
        <input type="text" placeholder="Your Full Name" required />
        <input type="number" placeholder="Contact-Number" required />
        <input type="email" placeholder="Professional Email Address" required />
        <textarea rows="6" placeholder="Project Operational Context" required />
        <button type="submit">Submit Request</button>
      </Form>
    </ContactSection>
  );
}